export interface ScenarioSeries {
  name: string;
  data: number[];
  color: string;
}

export interface ScenarioStat {
  label: string;
  value: number;
  color: string;
  isFocused?: boolean;
}

export interface ScenarioProjectionData {
  series: ScenarioSeries[];
  categories: string[];
  stats: ScenarioStat[];
}

export interface YearlyResult {
  year: number;
  principalAge: number | null;
  spouseAge: number | null;
  significantlyBelowAverage: number;
  belowAverage: number;
  average: number;
  aboveAverage: number;
}

export enum MonteCarloTab {
  SummaryOfTrials,
  MarketScenarios,
}

export enum MarketScenarioLabel {
  SignificantlyBelowAverage = 'Significantly Below Average',
  BelowAverage = 'Below Average',
  Average = 'Average',
  AboveAverage = 'Above Average',
}

export enum MarketScenarioPercentile {
  SignificantlyBelowAverage = 10,
  BelowAverage = 25,
  Average = 50,
  AboveAverage = 75,
}

export const MARKET_CONDITIONS = [
  {
    category: MarketScenarioLabel.AboveAverage,
    percentile: MarketScenarioPercentile.AboveAverage,
    header: 'Above Average (25th percentile — most optimistic)',
    description: '75% of simulations produced equivalent or worse results',
    color: '#3B82F6',
  },
  {
    category: MarketScenarioLabel.Average,
    percentile: MarketScenarioPercentile.Average,
    header: 'Average (50th percentile): the median outcome',
    description: 'half of simulations did better, half did worse',
    color: '#A78BFA',
  },
  {
    category: MarketScenarioLabel.BelowAverage,
    percentile: MarketScenarioPercentile.BelowAverage,
    header: 'Below Average (75th percentile)',
    description: '75% of simulations produced equivalent or better results',
    color: '#1E3A8A',
  },
  {
    category: MarketScenarioLabel.SignificantlyBelowAverage,
    percentile: MarketScenarioPercentile.SignificantlyBelowAverage,
    header: 'Significantly Below Average (90th percentile — most conservative)',
    description: '90% of simulations produced equivalent or better results',
    color: '#22C55E',
  },
];
